// Contexte du thème, séparé du composant ThemeProvider et du hook useTheme :
// Fast Refresh ne recharge que les fichiers qui n'exportent que des composants.
import { createContext } from 'react';

export type Theme = 'light' | 'dark';

export interface ThemeContextType {
    theme: Theme;
    toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
